import { render, staticRenderFns } from "./oilImport.vue?vue&type=template&id=64e27aee&scoped=true&"
import script from "./oilImport.vue?vue&type=script&lang=js&"
export * from "./oilImport.vue?vue&type=script&lang=js&"
import style0 from "./oilImport.vue?vue&type=style&index=0&id=64e27aee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e27aee",
  null
  
)

export default component.exports